import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SunOutlinedSvg from "@ant-design/icons-svg/es/asn/SunOutlined";
import AntdIcon from "../components/AntdIcon";
var SunOutlined = function SunOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SunOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SunOutlined.displayName = 'SunOutlined';
}
export default /*#__PURE__*/React.forwardRef(SunOutlined);